import type { SVGProps } from "react";
export interface HeadHeadphoneIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HeadHeadphoneIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HeadHeadphoneIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M13.374 10a2.875 2.875 0 1 0-5.75-.001 2.875 2.875 0 0 0 5.75.001M10 9.628a.62.62 0 0 0-.125.372l.013.126a.6.6 0 0 0 .112.245zm1 .743a.6.6 0 0 0 .113-.245l.011-.126-.011-.126A.6.6 0 0 0 11 9.628zM12.125 10a1.625 1.625 0 0 1-3.242.165L8.875 10l.008-.166a1.625 1.625 0 0 1 1.618-1.459l.165.008c.82.083 1.459.776 1.459 1.617m3.5 0a5.125 5.125 0 1 1-6.25-5.001V2.5a1.125 1.125 0 0 1 2.25 0v2.499a5.126 5.126 0 0 1 4 5.001"
      />
      <path
        fill={color}
        d="M2.875 22v-3.81c0-.863-.331-1.396-.882-2.505C1.446 14.585.875 13.207.875 11 .875 5.14 5.141.875 11 .875c4.878 0 8.384 3.602 9.519 7.945l.364 1.396c.365 1.353.758 2.573 1.442 3.642l.414.646.088.15c.85 1.548-.193 3.496-1.995 3.609l-.813.05-.212 2.014a3.124 3.124 0 0 1-3.107 2.797H14A4.125 4.125 0 0 1 9.875 19a1.125 1.125 0 0 1 2.25 0c0 1.035.84 1.875 1.875 1.875h2.7a.875.875 0 0 0 .87-.783l.223-2.12.029-.19a2.125 2.125 0 0 1 1.95-1.708l.92-.057.052-.01a.196.196 0 0 0 .122-.242l-.022-.048-.415-.646c-1.147-1.794-1.622-3.9-2.087-5.68-.943-3.608-3.728-6.266-7.342-6.266-4.617 0-7.875 3.258-7.875 7.875 0 1.745.429 2.772.882 3.684.449.903 1.118 1.99 1.118 3.507V22a1.125 1.125 0 0 1-2.25 0"
      />
    </svg>
  );
}
